interface SparePartStatusBadgeProps {
  status: string;
  className?: string;
}

const statusConfig: Record<string, { label: string; className: string }> = {
  sin_pedir: {
    label: 'Not ordered',
    className: 'bg-yellow text-nb-black border-3 border-nb-black',
  },
  pedido: {
    label: 'Ordered',
    className: 'bg-blue-500 text-white border-3 border-nb-black',
  },
  recibido: {
    label: 'Received',
    className: 'bg-green text-nb-black border-3 border-nb-black',
  },
};

export default function SparePartStatusBadge({
  status,
  className = '',
}: SparePartStatusBadgeProps) {
  const config = statusConfig[status] || {
    label: 'Unknown',
    className: 'bg-gray-400 text-white border-3 border-nb-black',
  };

  return (
    <span
      className={`
        inline-block
        font-nb font-bold
        text-xs px-1.5 py-0.5
        ${config.className}
        ${className}
      `.replace(/\s+/g, ' ').trim()}
    >
      {config.label}
    </span>
  );
}
